import {create} from 'zustand';

interface useSheetSidebarStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useSheetSidebarStore = create<useSheetSidebarStore>()(set => ({
  open: false,
  setOpen: (open: boolean) => set({open}),
}));
